import i18n from "@/i18n";
import { useAo3Site } from "@/hooks/ao3SiteContext";
import { useTranslation } from "react-i18next";

interface Ao3TogglesProps {
  tone?: "overlay" | "solid";
}

export default function Ao3Toggles({ tone = "solid" }: Ao3TogglesProps) {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useAo3Site();
  const isZh = (i18n.language || "en").startsWith("zh");

  const toneClass =
    tone === "overlay"
      ? "border-background-50/30 text-background-50 hover:bg-background-50/15 dark:border-foreground-950/30 dark:text-foreground-950 dark:hover:bg-foreground-950/15"
      : "border-background-300/70 text-foreground-700 hover:bg-background-200/70";

  const base = `inline-flex items-center gap-1.5 rounded-md border px-3 py-2 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${toneClass}`;

  return (
    <div className="flex items-center gap-2">
      <button type="button" onClick={() => i18n.changeLanguage(isZh ? "en" : "zh")} className={base} aria-label="Switch language">
        <i className="ri-translate-2 text-base leading-none" />
        <span>{t("nav.lang")}</span>
      </button>
      <button
        type="button"
        onClick={toggleTheme}
        className={`${base} px-2.5`}
        aria-label={theme === "dark" ? t("nav.theme.toLight") : t("nav.theme.toDark")}
        title={theme === "dark" ? t("nav.theme.toLight") : t("nav.theme.toDark")}
      >
        <i className={`${theme === "dark" ? "ri-sun-line" : "ri-moon-line"} text-base leading-none`} />
      </button>
    </div>
  );
}